import { render } from "./fugaojianyanjishu-news.vue?vue&type=template&id=c66e52ce&scoped=true"
import script from "./fugaojianyanjishu-news.vue?vue&type=script&lang=js"
export * from "./fugaojianyanjishu-news.vue?vue&type=script&lang=js"

import "./fugaojianyanjishu-news.vue?vue&type=style&index=0&id=c66e52ce&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c66e52ce"]])

export default __exports__